import { AxiosResponse } from 'axios';
import { ModelsNames } from 'utils/enums/model-names';
import { serverAxios } from 'utils/http';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { IGetActiveThemeResponse } from 'models/http/themes';

class ThemesHttp {
  protected readonly route = ModelsNames.Themes;

  public async getActive(accessToken: string, abortController?: AbortController): Promise<IGetActiveThemeResponse> {
    return serverAxios
      .get(`${this.route}/active`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response: AxiosResponse<IGetActiveThemeResponse>) => {
        return response.data;
      });
  }
}

export default ThemesHttp;
